<template>
  <div class="open-contract">
    <div class="title-page mb-16">
      {{ $t('menu::contract-manager::open-contract') || $route.meta.name }}
      <span v-if="$route.meta && $route.meta.showUserName">
        {{ $t('personal::my-contract::localAccount') }}：{{ $store.state.user.userName }}
      </span>
    </div>
    <div>
      <!-- 天付，仅测试用 -->
      <el-button
        :type="payType === 'd' ? 'primary' : ''"
        @click="changeType('d')"
        style="width: 116px; margin-right: 6px"
        v-if="hasDayType"
      >
        {{ $t('personal::my-contract::天付') }}
      </el-button>
      <el-button :type="payType === 'm' ? 'primary' : ''" @click="changeType('m')" style="width: 116px">
        {{ $t('personal::my-contract::月付') }}
      </el-button>
      <el-button
        :type="payType === 'y' ? 'primary' : ''"
        @click="changeType('y')"
        style="width: 116px; margin-left: 16px"
      >
        {{ $t('personal::my-contract::年付') }}
      </el-button>
    </div>
    <div class="contract-list">
      <div
        class="contract-wrap mt-24"
        v-for="item in contracts
          .filter(item => !!item.priceList.find(i => i.cycleUnit === payType) && lastSubscriptionGrade <= item.grade)
          .sort((a, b) => Number(a.sortWeight) - Number(b.sortWeight))"
        :key="item.id"
      >
        <div
          class="contract-item"
          :class="[
            { active: item.id === combo.id },
            { 'contract-item-collapse': collapse },
            { disabled: lastSubscriptionGrade > item.grade },
          ]"
          @click="chooseContract(item)"
        >
          <div class="contract-title">{{ item.name }}</div>
          <div class="contract-price">
            ${{ $dataCheck(item.priceInfo && item.priceInfo.price, 0) }}
            <span>/{{ filterUnit[item.priceInfo && item.priceInfo.cycleUnit] }}</span>
          </div>
          <div class="contract-desc">
            <p
              v-for="(re, index) in item.remark.split('\n')"
              :key="index"
              :class="{ smallcontent: item.id === lastContracts.id ? index != 0 : false }"
            >
              {{ re }}
            </p>
          </div>
          <transition name="el-fade-in-linear">
            <div class="choose-active" v-show="item.id === combo.id">
              <i class="el-icon-check"></i>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <footer-fixed>
      <el-button type="primary" @click="submit" :loading="loading">
        {{ $t('personal::contract::确认签约') }}
      </el-button>
      <p style="font-size: 12px; color: #999; margin-top: 12px">
        {{ $t('personal::contract::agree_tips') }}
        <a @click="toPdf">《{{ $t('personal::contract::服务协议') }}》</a>
      </p>
    </footer-fixed>
    <stripePay v-model="visible" :selectCombo="combo" :payCouponEnable="payCouponEnable"></stripePay>
  </div>
</template>

<script>
import ZDefaultData from '@/components/common/default-data/main'
import stripePay from '@/views/personal-center/contract-management/components/stripePay'
import { getPackageContract, getCouponSetting } from '@/server/personal/contract'
import { filterUnit } from './config'

export default {
  components: { ZDefaultData, stripePay },
  data() {
    return {
      filterUnit,
      contracts: [],
      payType: 'm',
      combo: '',
      customDefault: {
        height: '600px',
      },
      visible: false,
      payment: {},
      loading: false,
      hasDayType: false,
      payCouponEnable: false,
    }
  },
  mounted() {
    this.getPackage()
    this.getCouponSetting()
  },
  methods: {
    async getCouponSetting() {
      const { data } = await getCouponSetting()
      if (data.code === this.$code) {
        this.payCouponEnable = data.data.payEnable
      }
    },
    async submit() {
      if (!this.combo) return this.$message.warning('请选择套餐')
      this.$store.dispatch('buried', {
        event: 'Personal center click',
        packageId: this.combo.id,
        packagePaymentMethod: this.payType,
      })
      this.visible = true
    },
    chooseContract(item) {
      if (this.lastSubscriptionGrade > item.grade) return
      this.$store.dispatch('buried', {
        event: 'Personal center click',
        packageId: item.id,
        packagePaymentMethod: this.payType,
      })
      this.combo = item
    },
    async getPackage() {
      const { data } = await getPackageContract()
      if (data.code === this.$code) {
        this.contracts = data.data || []
        if (this.contracts.length) {
          this.lastContracts = data.data[data.data.length - 1]
          for (let item of this.contracts) {
            if (item.priceList.some(i => i.cycleUnit === 'd')) {
              this.hasDayType = true
            }
          }
        }
        this.filterContracts()
      }
    },
    toPdf() {
      window.open('/xieyi.pdf', '_blank')
    },
    changeType(type) {
      this.payType = type
      this.combo = ''
    },
    filterContracts() {
      this.contracts.forEach(item => {
        const info = item.priceList.find(i => i.cycleUnit === this.payType)
        if (info) {
          item.priceInfo = info
        }
      })
    },
  },
  computed: {
    collapse() {
      return this.$store.state.menu.collapse
    },
    lastSubscriptionGrade() {
      return this.$store.state.user.combo.lastSubscriptionGrade
        ? this.$store.state.user.combo.lastSubscriptionGrade
        : null
    },
  },
  watch: {
    payType() {
      this.filterContracts()
    },
  },
}
</script>

<style scoped lang="scss">
.title-page {
  font-size: 20px;
  font-weight: bold;
  color: $--text-26;
  span {
    font-size: 14px;
    font-weight: bold;
    color: #999999;
  }
}
.open-contract {
  padding-bottom: 80px;
}
.contract-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px 0 -12px;
}
.contract-wrap {
  width: 16.6%;
  padding: 0 12px;
  box-sizing: border-box;
  .contract-item {
    &.disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    position: relative;
    height: 350px;
    padding: 24px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    border: 1px solid transparent;
    box-sizing: border-box;
    &.active {
      border: 1px solid #0560fd;
    }
    &:hover {
      box-shadow: 0px 2px 20px 0px rgba(59, 43, 43, 0.1);
    }
    .contract-title {
      font-size: 18px;
      font-weight: bold;
      color: #010517;
    }
    .contract-price {
      font-size: 20px;
      font-weight: bold;
      color: #0560fd;
      margin: 16px 0;
      span {
        font-size: 12px;
        font-weight: normal;
      }
    }
    .contract-desc {
      flex: 1;
      position: relative;
      padding: 16px;
      background: #f9f9f9;
      border-radius: 8px;
      color: #666;
      p {
        font-size: 14px;
        line-height: 32px;
        white-space: normal;
        text-align: start;
      }
      .smallcontent {
        font-size: 12px;
        line-height: 28px;
        color: #666;
      }
    }
    .choose-active {
      position: absolute;
      top: -1px;
      right: -1px;
      border-top-right-radius: 4px;
      width: 0;
      height: 0;
      border-width: 22.5px;
      border-style: solid;
      border-color: #0560fd #0560fd transparent transparent;
      .el-icon-check {
        position: absolute;
        top: -20px;
        left: 2px;
        font-size: 16px;
        color: #fff;
      }
    }
  }
}
@media screen and (min-width: 1600px) and (max-width: 1919px) {
  .contract-wrap {
    width: 20%;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1600px) {
  .contract-wrap {
    width: 25%;
  }
}
@media screen and (max-width: 1200px) {
  .contract-wrap {
    width: 33.3%;
  }
}
</style>
